// extracted by mini-css-extract-plugin
var _1 = "styles-module__addReviewBtn___jxbWN";
var _2 = "styles-module__attributeTitle___ITl6L";
var _3 = "styles-module__attributes___sYmix";
var _4 = "styles-module__banner___P2WEs";
var _5 = "styles-module__blockSection___KErOb";
var _6 = "styles-module__container___f1liH";
var _7 = "styles-module__dateAndActivity___HyeGo";
var _8 = "styles-module__description___xOSFS";
var _9 = "styles-module__editReviewLink___SBhrH";
var _a = "styles-module__garminButton___QxdM6";
var _b = "styles-module__heartButton___XdtFz";
var _c = "styles-module__metadata___QHuNx";
var _d = "styles-module__nameAndDescription___vxiRq";
var _e = "styles-module__nameAndStars___Ae6fz";
var _f = "styles-module__plusBadge___XRWNu";
var _10 = "styles-module__privacyDropdown___mEaGT";
var _11 = "styles-module__ratingTags___pKoz8";
var _12 = "styles-module__reviewComment___WNT3m";
var _13 = "styles-module__reviews2TrackName___J0NYI";
var _14 = "styles-module__starRatingIconClass___aK7Fn";
var _15 = "styles-module__starsBlock___SJJrn";
export { _1 as "addReviewBtn", _2 as "attributeTitle", _3 as "attributes", _4 as "banner", _5 as "blockSection", _6 as "container", _7 as "dateAndActivity", _8 as "description", _9 as "editReviewLink", _a as "garminButton", _b as "heartButton", _c as "metadata", _d as "nameAndDescription", _e as "nameAndStars", _f as "plusBadge", _10 as "privacyDropdown", _11 as "ratingTags", _12 as "reviewComment", _13 as "reviews2TrackName", _14 as "starRatingIconClass", _15 as "starsBlock" }
